<template>
    <div class="mt-2">

        <v-container>
            <v-layout row wrap class="justify-space-around">
                <v-flex xs12 sm12 md9>
                    <v-card class="mx-2">
                        <v-card-text>
                            <div>
                                <h1>Le programme du stage de récupération de points</h1>

                                <p>Si vous avez perdu des points sur votre permis de conduire suite à plusieurs
                                    infractions
                                    routières et que votre solde a dangereusement diminué, il est alors temps de
                                    participer à un
                                    stage de sensibilisation à la sécurité routière. Celui-ci s’effectue au sein d’un
                                    centre agréé.</p>
                            </div>

                            <div>
                                <h2>Comment se déroule un stage de récupération de points</h2>

                                <p>Un stage volontaire ou un stage obligatoire en période probatoire permettent de
                                    récupérer
                                    jusqu’à 4 points.</p>

                                <p>A l’inverse, un stage obligatoire émanant d’une décision judiciaire ne peut pas
                                    permettre de
                                    récupérer des points.</p>

                                <p>Le stage se déroule pendant deux jours consécutifs. Les horaires se situent le plus
                                    souvent
                                    entre 8h30 et 12h30 puis entre 13h30 et 17h30.</p>

                                <p>Lors de votre inscription à l’un de nos stages, vous recevrez une convocation
                                    comportant la
                                    date, le lieu et les horaires du stage.</p>

                                <p>Vous devez absolument respecter les horaires du stage qui vous auront été
                                    communiqués. Si
                                    vous arrivez en retard ou si vous êtes absent, les animateurs peuvent refuser de
                                    vous laisser
                                    participer au stage. Le stage reste dû et vous ne pourrez pas être transféré vers
                                    une autre
                                    session. Vous devrez alors vous réinscrire à un stage ultérieur.</p>

                                <p>Nous vous rappelons que vous ne pourrez pas fractionner votre stage sur deux sessions
                                    différentes.</p>
                                <p>Le programme du stage de récupération de points de permis</p>
                                <p>Le programme de deuxième génération que nous vous proposons à présent a été conçu en
                                    tenant compte des études qui ont été effectuées par des animateurs expérimentés.
                                    Celles-ci
                                    ont été menées sous l’autorité de l’Institut français des sciences et technologies
                                    des
                                    transports, de l’aménagement et des réseaux (IFSTTAR). Ainsi, il tient compte des
                                    évolutions
                                    de la société ainsi que des changements qui sont apparus concernant la sécurité
                                    routière.
                                    Leur objectif est d’amener les conducteurs à modifier leur attitude et leur
                                    comportement.</p>
                            </div>
                            <div>
                                <h1>Voici le programme du stage :</h1>

                                <h2>Jour 1</h2>

                                <ul>
                                    <li>Le tour de table : il permet de présenter le programme ainsi que les objectifs
                                        du
                                        stage et les participants. C’est aussi l’occasion de rappeler le dispositif
                                        réglementaire
                                        concernant le permis à points.
                                    </li>

                                    <li>La transmission de données de sécurité routière concernant l’insécurité routière
                                        en
                                        France (nombre de blessés sur les routes, de morts, circonstances et types
                                        d’usagers…)
                                    </li>

                                    <li>L’accidentologie permet que les participant prennent connaissance des causes et
                                        des
                                        circonstances principales des accidents ainsi que des populations à risque. La
                                        discussion est basée sur une étude de cas d’accident.
                                    </li>

                                    <li>Le questionnaire pour autoévaluer les connaissances des participants leur permet
                                        de
                                        réactualiser leurs connaissances concernant le code de la route.
                                    </li>
                                    <li>Les données psychophysiologiques permettent l’analyse et la compréhension des
                                        soucis d’interaction et de communication entre les divers usagers de la
                                        circulation.
                                        Les participants effectuent alors des exercices basés sur des situations de
                                        conduite
                                        ainsi que sur la conduite en elle-même.
                                    </li>
                                    <li>La possibilité de choisir un module spécifique portant sur une thématique telle
                                        que la
                                        vitesse ou les produits psychoactifs.
                                    </li>
                                </ul>

                                <h2>Jour 2</h2>

                                <p>
                                    Il comporte un enseignement spécialisé découpé en 3 phases. Celles-ci concernent les
                                    produits psychoactifs et la vitesse.</p>
                                <p>
                                    La récupération des 4 points n’est soumise à aucun examen final. Elle dépend
                                    seulement de
                                    votre assiduité.
                                </p>

                                <h2>En quoi consiste le contenu du stage</h2>

                                <p>Le stage est constitué d’un programme unique défini pour la France entière. Les
                                    animateurs
                                    abordent donc les facteurs généraux qui causent de l’insécurité routière ainsi que
                                    des
                                    enseignements adaptés concernant aussi bien l’alcool au volant et la vitesse que la
                                    conduite
                                    de poids lourds. Certains thèmes peuvent être abordés en fonction des choix
                                    effectués par
                                    les participants au stage.</p>

                                <p>L’objectif du stage est que chaque participant parvienne à :</p>

                                <ul>
                                    <li>Une réflexion sur sa propre conduite. Ainsi, la perception du conducteur, sa
                                        physiologie, les motivations et l’infraction routière sont abordés. De plus, le
                                        questionnaire d’auto-évaluation lui permet de faire le point sur ses
                                        connaissances.
                                    </li>
                                    <li>Une mise en commun de ses réflexions avec celles des autres stagiaires. Ceci
                                        s’effectue grâce à des tours de table et à la verbalisation de leurs
                                        représentations
                                        concernant la conduite.
                                    </li>
                                    <li>L’étude d’un cas pratique telle que l’analyse d’un accident</li>
                                    <li>La connaissance d’informations particulières concernant les lois physiques et
                                        les
                                        conséquences qu’elles peuvent avoir sur la conduite.
                                    </li>
                                </ul>

                                <h2>Mettons fin aux idées reçues !</h2>

                                <p>Il est important de ne pas confondre le stage de récupération de points avec une
                                    auto-école.
                                    En effet, il ne fait l’objet d’aucun examen ni épreuve pratique. De même, il ne
                                    s’agit pas
                                    d’une révision intensive du code la route.</p>

                                <p>Ce type de stage est basé sur les échanges entre les participants au sein du groupe.
                                    C’est en
                                    partageant leur situation et leurs expériences respectives qu’ils peuvent parvenir à
                                    prendre
                                    conscience des risques encourus.</p>
                                <p> Nous vous conseillons de participer pleinement à ce stage même si votre seule
                                    motivation
                                    de départ est la récupération de points. Ce stage permis à points se révèlera aussi
                                    utile pour
                                    vous-même que pour le groupe dans lequel vous vous trouverez alors. N’ayez pas peur
                                    de
                                    donner votre opinion et de partager votre vision des choses en toute honnêteté.</p>

                                <h2>Réglementation du stage par la Préfecture</h2>

                                <p>Le stage doit répondre à certaines conditions afin d’être valide :</p>

                                <ul>
                                    <li>L’animation doit être assurée par 2 formateurs sécurité routière agréées par le
                                        Ministère des transports. Il s’agit d’un spécialiste de la formation à la
                                        sécurité
                                        routière (BAFM) et d’un psychologue.
                                    </li>
                                    <li>La participation de 6 à 20 conducteurs. Le stage doit être annulé si le nombre
                                        minimal de participants déterminé par la Préfecture n’est pas atteint. Si ce
                                        n’est pas
                                        le cas, le stage sera alors invalidé
                                    </li>
                                    <li>Le stage doit se dérouler dans un centre agréé.</li>
                                </ul>

                                <h2>L’avantage de la récupération automatique de points après le stage</h2>

                                <p>A l’issue du stage, une attestation de stage est remise à chacun des participants.
                                    Elle valide
                                    la participation au stage. La récupération des 4 points est effective dès le
                                    lendemain de la fin
                                    du stage. Ainsi, les points ne seront pas crédités le soir qui correspond à la fin
                                    des 2 jours de
                                    stage mais le lendemain.</p>

                                <p>L’attestation n’est remise qu’aux participants ayant été présents et ponctuels
                                    pendant les
                                    deux jours du stage.</p>

                                <p>Les animateurs sont responsables de refuser l’accès au stage aux retardataires et aux
                                    absentéistes. En cas de refus d’accès, aucune validation de stage ne sera remise au
                                    conducteur. Il n’aura pas non plus validé sa récupération de points mais restera
                                    redevable
                                    du coût du stage.</p>
                            </div>
                        </v-card-text>
                    </v-card>

                </v-flex>
                <v-flex xs12 sm12 md3>
                    <v-card class="mx-2">
                        <v-card-text>
                            <RightAsideInfractions></RightAsideInfractions>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>

        <Footer/>
    </div>
</template>

<script>
    import RightAsideInfractions from '@/components/RightAsideInfractions'
    import Footer from '@/components/Footer'

    export default {
        name: "stage-recuperation-points",
        components: {
            RightAsideInfractions,
            Footer
        }
    }
</script>

<style>
    .highlighted {
        background: #ffedf5;
        border-radius: 10px;
        color: #7a0439;
        font-size: 18px;
        font-weight: 800;
        padding: 10px;
    }

    .highlighted p {
        font-size: 18px;
    }

    ul li {
        list-style-type: circle;
        margin: 10px 0 10px 0;
    }

    a {
        text-decoration: none;
    }

    a:hover {
        color: black;
    }

    p {
        font-size: 16px;
    }
</style>
